import { render, staticRenderFns } from "./formatted-address.vue?vue&type=template&id=36023c85&"
import script from "./formatted-address.vue?vue&type=script&lang=js&"
export * from "./formatted-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports